import tuneInRequest from '../tuneInRequest';
export default function createCmsService(config, apiContext) {
    function getRedirect(path) {
        return tuneInRequest({
            method: 'get',
            url: `${config.domains.radiomill}/redirects/cms/lookup/`,
            params: {
                path,
            },
            noAuthHeader: true,
        }, apiContext);
    }
    return {
        getRedirect,
    };
}
